<template>
</template>

<script>
export default {

  name: 'IntermediateFlowsupplierPage',

  data () {
    return {

    }
  },
  mounted()
  {
  	this.redirect()
  },
  methods:{
  	async redirect()
  	{
  		let flowsupplier_uuid = await this.$route.params.flowsupplier_uuid
  		let projectsupplier = await this.silentApiGet("audit/get_project_supplier_id/"+flowsupplier_uuid)

  		await this.$router.push({ name: 'SupplierProjectFlowSummary',params:{id:projectsupplier.supplier_id,project_id:projectsupplier.uuid,flow_id:flowsupplier_uuid} })

  	}
  },
}
</script>

<style lang="css" scoped>
</style>